<template>
<div class="card">
    <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="true">
    </loading>
    <div class="card-content">
        <div class="columns">
            <div class="column is-full">
                <nav class="level">
                    <div class="level-left">
                        <div class="level-item"><h3>Create New Item</h3></div>
                    </div>
                    <div class="level-right">
                        <div class="level-item"><b-field><b-switch type="is-info" true-value="1" false-value="0" :left-label='true' v-model="status">{{ statusLabel(status) }}</b-switch></b-field></div>
                    </div>
                </nav>
            </div>
        </div>
        <div class="columns">
            <div class="column is-6">
                <b-field label="Item Name">
                    <b-input v-model="name"></b-input>
                </b-field>
                <div class="columns">
                    <div class="column is-3">
                        <b-field label="Points Weight" v-show="dataType != 3">
                            <b-input type="number" min="-100" max="100" v-model="points" style="width: 100px;"></b-input>
                        </b-field>
                    </div>
                    <div class="column">
                        <b-field label="Item Type">                                
                            <b-select id="dataType" name="dataType" v-model="dataType" expanded>
                                <option value="1">Normal</option>
                                <option value="2">Attendance</option>
                                <option value="4">Parent (only appear in Parent app)</option>
                                <option value="5">Subject Attendance</option>
                            </b-select>
                        </b-field>
                    </div>
                </div>
                <div class="columns">
                    <div class="column is-7">
                        <b-field label="Limit Submission" v-model="points" v-show="(dataType == 1 || dataType == 4 || dataType == 5)">
                            <div class="columns">
                                <div class="column is-5">
                                    <b-input type="number" min="-1" max="100" v-model="submissionLimit" style="width: 100px;" :disabled=isSubmissionLimitDisabled></b-input>
                                </div>
                                <div class="column is-7">
                                    <b-select id="submissionLimitType" name="submissionLimitType" v-model="submissionLimitType" @input="submissionLimitTypeDisplay()">
                                        <option value="1">By daily</option>
                                        <option value="2">By yearly</option>
                                        <option value="-1">NO Limit</option>
                                    </b-select>
                                </div>
                            </div>
                        </b-field>
                    </div>
                    <div class="column is-5">
                        <b-field label="Linear Scale" v-model="points" v-show="(dataType == 1 || dataType == 4 || dataType == 5)">
                            <div class="columns">
                                <div class="column is-3" style="margin-top: 7px;">
                                    1 to
                                </div>
                                <div class="column is-9">
                                    <b-input type="number" min="1" max="100" v-model="scaleLimit" />
                                </div>
                            </div>
                        </b-field>
                    </div>
                </div>
            </div>
            <div class="column is-6">
                <b-field label="EXTRA INFORMATION (OPTIONAL)">
                    <b-input v-model="info"></b-input>
                </b-field>
                <b-field label="PERSON IN CHARGE (LEAVE BLANK IF AVAILABLE TO ALL)">
                    <multiselect v-model="restrictAwardTo" :options="listTeachers" :close-on-select="false" :multiple="true" :hide-selected="true" label="firstName" track-by="_id"></multiselect>
                </b-field>
                <b-field label="INCLUDE IN WHICH CATEGORY?">
                    <multiselect v-model="tags" :options="listTags" :close-on-select="false" :multiple="true" :hide-selected="true" label="name" track-by="_id" placeholder="Categories"></multiselect>
                </b-field>
                <div style="margin-start: 5px; margin-top: -10px; font-size: 12px; color: rgb(46, 142, 252); font-weight: bold;" v-on:click="goManageBehaviorTags()">Manage Category</div>
            </div>
        </div>
        <div class="columns">
            <div class="column is-7">
                <b-field label="CHOOSE THEME COLOUR">
                    <v-swatches v-model="colour" shapes="circles" inline></v-swatches>
                </b-field>
            </div>
            <div class="column is-5">
            </div>
        </div>
        <div class="columns">
            <div class="column is-2" style="margin-top: 5px;">
                <b-checkbox v-model="isRemarksMandatory"
                    name="isRemarksMandatory" true-value="1" false-value="0"
                    class="radio-label">
                    REMARKS IS COMPULSORY
                </b-checkbox>
            </div>
            <div class="column is-2" style="margin-top: 5px;">
                <b-checkbox v-model="sendNotification"
                    name="sendNotification" true-value="1" false-value="0"
                    class="radio-label">
                    NOTIFICATION TO PARENT APP
                </b-checkbox>
            </div>
            <div class="column is-2" style="margin-top: 5px;" v-show="((dataType == 1) || (dataType == 2) || (dataType == 5))">
                <b-checkbox v-model="enableFaceCapture"
                    name="enableFaceCapture" true-value="1" false-value="0"
                    native-value="1" class="radio-label" :disabled=isFaceCaptureDisabled>
                    FACE CAPTURE IN KIOSK MODE
                </b-checkbox>
            </div>
            <div class="column is-2" style="margin-top: 5px;">
                <b-checkbox v-model="enableLocation"
                    name="enableLocation" true-value="1" false-value="0"
                    native-value="1" class="radio-label" :disabled=isLocationDisabled>
                    ENABLE LOCATION INFORMATION
                </b-checkbox>
            </div>
            <div class="column is-3">
                <b-button type="is-primary" v-on:click="sendForm()" expanded>Save</b-button>
            </div>
            <div class="column is-1">
                <b-button type="is-secondary" v-on:click="isComponentModalActive = false" expanded>X</b-button>
            </div>
        </div>
        <div class="columns" v-show="((schoolID == '6099e8d1e567ab06f84b8d17') || (schoolID == '5c1a735fc98da061141475a1'))"><!-- Only forPUNB -->
            <div class="column is-12">
                <div>
                    <h3>Only for PUNB</h3>
                    <div class="field">
                        <label class="label">Make this item only Yes or No?</label>
                        <div class="control">
                            <label class="radio">
                                <input type="radio" v-model="customBehaviorYesNo" value="1">
                                Yes
                            </label>
                            <label class="radio">
                                <input type="radio" v-model="customBehaviorYesNo" value="-1" checked>
                                No
                            </label>
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">Allow only numerics in remarks?</label>
                        <div class="control">
                            <label class="radio">
                                <input type="radio" v-model="customBehaviorRemarksInt" value="1">
                                Yes
                            </label>
                            <label class="radio">
                                <input type="radio" v-model="customBehaviorRemarksInt" value="-1" checked>
                                No
                            </label>
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">Allow negative mutiplier?</label>
                        <div class="control">
                            <label class="radio">
                                <input type="radio" v-model="customBehaviorNegativeMultiplier" value="1">
                                Yes
                            </label>
                            <label class="radio">
                                <input type="radio" v-model="customBehaviorNegativeMultiplier" value="-1" checked>
                                No
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import { ToastProgrammatic as Toast } from 'buefy'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VSwatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'

export default {
    name: "ManageKelasAdd",
    components:{
        Multiselect,
        Loading,
        VSwatches
    },
    data() {
        return {
            schoolID: "",
            schoolPlan: 1,
            isLoading: false,
            listTeachers: [],
            listTags: [],
            name: '',
            points: 1,
            dataType: 1,
            restrictAwardBy: 1,
            restrictAwardTo: [],
            scaleLimit: 5,
            submissionLimitType: 1,
            submissionLimit: 5,
            isSubmissionLimitDisabled: false,
            status: 1,
            colour: '#0C4BF7',
            tags: [],
            info: "",
            customBehaviorYesNo: -1,
            customBehaviorRemarksInt: -1,
            customBehaviorNegativeMultiplier: -1,
            isMandatory: 0,
            isRemarksMandatory: 0,
            sendNotification: 1,
            enableFaceCapture: 0,
            isFaceCaptureDisabled: 0,
            enableLocation: 0,
            isLocationDisabled: 0,
            attendanceLateTime: new Date(),
            swatches: ['#1FBC9C', '#1CA085', '#2ECC70', '#27AF60', '#3398DB', '#2980B9', '#A463BF', '#8E43AD', '#3D556E', '#222F3D', '#F2C511', '#F39C19', '#E84B3C', '#C0382B', '#DDE6E8', '#BDC3C8' ]
        };
    },
    created() {
        this.schoolID = localStorage.getItem('schoolID');
        console.log("239 schoolID: " + this.schoolID)
        this.getTeacherList();        
        this.getTagList();        
        this.schoolPlan = localStorage.getItem('plan')

        if (this.schoolPlan == 1){
            this.isFaceCaptureDisabled = false
            this.isLocationDisabled = false
        }else{
            this.isFaceCaptureDisabled = true
            this.isLocationDisabled = true
        }

        //PUNB SCHOOLID UTK COME CUSTOMIZATION 6099e8d1e567ab06f84b8d17
    },
    methods: {
        submissionLimitTypeDisplay(){
            console.log("masuk 249")
            if (this.submissionLimitType == -1){
                // this.submissionLimit = "-1"
                this.isSubmissionLimitDisabled = true;
            }else{
                this.isSubmissionLimitDisabled = false;
            }
        },
        statusLabel(status){
            if (status == "1"){
                return "ACTIVE"
            }else{
                return "INACTIVE"
            }
        },
        sendForm() {
            let self = this;

            var name = self.name;
            var points = self.points;
            var dataType = self.dataType;
            var restrictAwardBy = self.restrictAwardBy;
            var restrictAwardTo = self.restrictAwardTo;
            
            var scaleLimit = self.scaleLimit;
            var submissionLimitType = self.submissionLimitType;
            var submissionLimit = self.submissionLimit;

            var status = self.status;
            var colour = self.colour;
            var info = self.info;
            var isMandatory = self.isMandatory;
            var isRemarksMandatory = self.isRemarksMandatory;
            var sendNotification = self.sendNotification;
            var enableFaceCapture = self.enableFaceCapture;
            var enableLocation = self.enableLocation;
            var selectedColour = "#0C4BF7";
            var tags = self.tags;
            var finalStatus = status
            var customBehaviorYesNo = self.customBehaviorYesNo
            var customBehaviorRemarksInt = self.customBehaviorRemarksInt
            var customBehaviorNegativeMultiplier = self.customBehaviorNegativeMultiplier

            if ((!name) || (name.length < 1)){
                Toast.open({
                    message: "Please enter the behavior name",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }else{
                name = name.trim()
            }
            if (!points){
                points = 0
            }
            if ((self.schoolID == '6099e8d1e567ab06f84b8d17') || (self.schoolID == '5c1a735fc98da061141475a1')){
                if (dataType != 3){
                    if ((customBehaviorYesNo == 1) || (customBehaviorRemarksInt == 1)){
                        console.log("no points is OK here, also force set the points to 0")
                        points = 0
                    }else{
                        if (points == 0){
                            Toast.open({
                                message: "Please enter the points for this behavior",
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 3000
                            })
                            return false;
                        }
                    }
                }
            }else{
                if (dataType != 3){
                    if (points == 0){
                        Toast.open({
                            message: "Please enter the points for this behavior",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 3000
                        })
                        return false;
                    }
                }
            }
            if (restrictAwardBy == 3){
                if ((!restrictAwardTo) || (restrictAwardTo.length < 1)){
                    Toast.open({
                        message: "Please select the teachers that can use this behavior",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 3000
                    })
                    return false;
                }
            }
            if (dataType != 1){
                isMandatory = 0;    //isMandatory is only available for normal behaviors
            }
            if (restrictAwardBy != 1){
                isMandatory = 0;    //isMandatory is only available for behaviors that can be submitted by all
            }
            
            
            scaleLimit = parseInt(scaleLimit)
            if (scaleLimit === parseInt(scaleLimit, 10)){
                console.log("masuk 388 with scaleLimit: " + scaleLimit)
            }else{
                Toast.open({
                    message: "Please enter the maximum scale for the item " + name + ". Enter -1 to make it unlimited.",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }
            console.log("397 scaleLimit: " + scaleLimit)            

            if (submissionLimitType < 1){
                this.$swal({
                    title: "Are you sure? ",
                    text: "Are you really sure you want to set this item " + name + "'s submission count to UNLIMITED?",
                    showDenyButton: true,
                    showCancelButton: false,
                    confirmButtonText: `Yes, make this item submission UNLIMITED`,
                    denyButtonText: `No, let me fix this`,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.continue1(self,name,points,dataType,restrictAwardBy,restrictAwardTo,scaleLimit,submissionLimitType,submissionLimit,status,finalStatus,colour,selectedColour,tags,info,isMandatory,isRemarksMandatory,sendNotification,enableFaceCapture,enableLocation,customBehaviorYesNo,customBehaviorRemarksInt,customBehaviorNegativeMultiplier)
                    } else if (result.isDenied) {           
                        console.log("425 return false")          
                        return false;
                    }
                })
            }else{
                submissionLimit = parseInt(submissionLimit)
                if (submissionLimit === parseInt(submissionLimit, 10)){
                    console.log("masuk 383")
                    if (submissionLimit < 1){
                        Toast.open({
                            message: "Please enter the daily or yearly submission limit for the item " + name,
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 3000
                        })
                        return false;
                    }else{

                        this.continue1(self,name,points,dataType,restrictAwardBy,restrictAwardTo,scaleLimit,submissionLimitType,submissionLimit,status,finalStatus,colour,selectedColour,tags,info,isMandatory,isRemarksMandatory,sendNotification,enableFaceCapture,enableLocation,customBehaviorYesNo,customBehaviorRemarksInt,customBehaviorNegativeMultiplier)
                    }
                }else{
                    Toast.open({
                        message: "Please enter the daily or yearly submission limit for the item " + name,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 3000
                    })
                    return false;
                }
                console.log("473")
            }

        },

        continue1(self,name,points,dataType,restrictAwardBy,restrictAwardTo,scaleLimit,submissionLimitType,submissionLimit,status,finalStatus,colour,selectedColour,tags,info,isMandatory,isRemarksMandatory,sendNotification,enableFaceCapture,enableLocation,customBehaviorYesNo,customBehaviorRemarksInt,customBehaviorNegativeMultiplier){            
            
            if (!status){
                status = 0
            }else{
                status = parseInt(status)
            }
            if (dataType == 3){
                enableLocation = 0;    //enableLocation is not available for notifications
                enableFaceCapture = 0;    //enableFaceCapture is not available for notifications
            }
            if (dataType == 4){
                enableFaceCapture = 0;    //enableFaceCapture is not available for parents app
            }
            if (!colour.hex){
                selectedColour = "#0C4BF7"
            }else{
                selectedColour = colour.hex
            }

            //Only for PUNB
            if (!customBehaviorYesNo){
                customBehaviorYesNo = -1
            }else{
                customBehaviorYesNo = parseInt(customBehaviorYesNo)
            }
            if (!customBehaviorRemarksInt){
                customBehaviorRemarksInt = -1
            }else{
                customBehaviorRemarksInt = parseInt(customBehaviorRemarksInt)
            }
            if (!customBehaviorNegativeMultiplier){
                customBehaviorNegativeMultiplier = -1
            }else{
                customBehaviorNegativeMultiplier = parseInt(customBehaviorNegativeMultiplier)
            }
            //end for PUNB

            var tagActiveCount = 0
            var tagInactiveCount = 0
            if (tags.length > 0){
                for (var i = 0; i < tags.length; i++){
                    if (tags[i].status == 1){
                        tagActiveCount = tagActiveCount + 1
                    }else{
                        tagInactiveCount = tagInactiveCount + 1
                    }
                }
            }

            if ((status == 0) && (tagActiveCount > 0)){
                
                this.$swal({
                    title: "Please choose? ",
                    text: "You set this behavior to INACTIVE, but you linked to at least one tag that is ACTIVE. Please choose whether you want this behavior to be ACTIVE or INACTIVE.",
                    showDenyButton: true,
                    showCancelButton: true,
                    confirmButtonText: `Active`,
                    denyButtonText: `Inactive`,
                }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                        // this.$swal.fire('Saved!', '', 'success')
                        finalStatus = 1
                        this.continueAdd(self,name,points,dataType,restrictAwardBy,restrictAwardTo,scaleLimit,submissionLimitType,submissionLimit,finalStatus,selectedColour,tags,info,isMandatory,isRemarksMandatory,sendNotification,enableFaceCapture,enableLocation,customBehaviorYesNo,customBehaviorRemarksInt,customBehaviorNegativeMultiplier)
                    } else if (result.isDenied) {
                        // this.$swal.fire('Changes are not saved', '', 'info')                        
                        finalStatus = 0
                        this.continueAdd(self,name,points,dataType,restrictAwardBy,restrictAwardTo,scaleLimit,submissionLimitType,submissionLimit,finalStatus,selectedColour,tags,info,isMandatory,isRemarksMandatory,sendNotification,enableFaceCapture,enableLocation,customBehaviorYesNo,customBehaviorRemarksInt,customBehaviorNegativeMultiplier)
                    }
                })

                return false;
            }

            if ((status == 1) && (tagInactiveCount > 0)){
                
                this.$swal({
                    title: "Please choose? ",
                    text: "You set this behavior to ACTIVE, but you linked to at least one tag that is INACTIVE. Please choose whether you want this behavior to be INACTIVE or ACTIVE.",
                    showDenyButton: true,
                    showCancelButton: true,
                    confirmButtonText: `Active`,
                    denyButtonText: `Inactive`,
                }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                        finalStatus = 1
                        this.continueAdd(self,name,points,dataType,restrictAwardBy,restrictAwardTo,scaleLimit,submissionLimitType,submissionLimit,finalStatus,selectedColour,tags,info,isMandatory,isRemarksMandatory,sendNotification,enableFaceCapture,enableLocation,customBehaviorYesNo,customBehaviorRemarksInt,customBehaviorNegativeMultiplier)
                    } else if (result.isDenied) {                    
                        finalStatus = 0
                        this.continueAdd(self,name,points,dataType,restrictAwardBy,restrictAwardTo,scaleLimit,submissionLimitType,submissionLimit,finalStatus,selectedColour,tags,info,isMandatory,isRemarksMandatory,sendNotification,enableFaceCapture,enableLocation,customBehaviorYesNo,customBehaviorRemarksInt,customBehaviorNegativeMultiplier)
                    }
                })

                return false;
            }

            if (tagInactiveCount <= 0){
                this.continueAdd(self,name,points,dataType,restrictAwardBy,restrictAwardTo,scaleLimit,submissionLimitType,submissionLimit,finalStatus,selectedColour,tags,info,isMandatory,isRemarksMandatory,sendNotification,enableFaceCapture,enableLocation,customBehaviorYesNo,customBehaviorRemarksInt,customBehaviorNegativeMultiplier)
            }

        },
        continueAdd(self,name,points,dataType,restrictAwardBy,restrictAwardTo,scaleLimit,submissionLimitType,submissionLimit,status,selectedColour,tags,info,isMandatory,isRemarksMandatory,sendNotification,enableFaceCapture,enableLocation,customBehaviorYesNo,customBehaviorRemarksInt,customBehaviorNegativeMultiplier){
            self.isLoading = true;

            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/behaviors/add/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                name: name,
                points: points,
                dataType: dataType,
                restrictAwardBy: restrictAwardBy,
                restrictAwardTo: restrictAwardTo,
                scaleLimit: scaleLimit,
                submissionLimitType: submissionLimitType,
                submissionLimit: submissionLimit,
                status: status,
                colour: selectedColour,
                tags: tags,
                info: info,
                isMandatory: isMandatory,
                isRemarksMandatory: isRemarksMandatory,
                sendNotification: sendNotification,
                enableFaceCapture: enableFaceCapture,
                enableLocation: enableLocation,
                customBehaviorYesNo: customBehaviorYesNo,
                customBehaviorRemarksInt: customBehaviorRemarksInt,
                customBehaviorNegativeMultiplier: customBehaviorNegativeMultiplier,
            })
            .then(response => {
                self.isLoading = false;
                if (response.data.success == false) {
                    Toast.open({
                        message: response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        message: response.data.msg,
                        type: 'is-success',
                        duration: 3000
                    })
                }

                self.name = ""
                self.points = ""
                self.dataType = 1
                self.restrictAwardBy = 1
                self.restrictAwardTo = []
                self.scaleLimit = 5
                self.submissionLimitType = 1
                self.submissionLimit = 5
                self.status = 1
                self.tags = []
                self.info = ""
                self.isMandatory = 0
                self.isRemarksMandatory = 0
                self.sendNotification = 1
                self.enableFaceCapture = 0
                self.enableLocation = 0
                self.$parent.getData()
            })
            .catch(e => {
                self.isLoading = false;
                console.log(e.response)
                if (e.response.status === 401) {                            
                    Toast.open({
                        message: "Unauthorized access. Please re-login.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        message: 'Error: ' + e.response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                }
            })
        },
        getTeacherList(){
            let self = this;            
            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/teachers/list/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email')
            })
            .then(response => {
                self.listTeachers = response.data
            })
            .catch(e => {
                console.log(e)
            })
        },
        getTagList(){
            let self = this;            
            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/behaviors/tagList/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email')
            })
            .then(response => {
                self.listTags = response.data
            })
            .catch(e => {
                console.log(e)
            })
        },
        goManageBehaviorTags(){
            this.$router.push({
                name: "ManageBehaviorsTagsHome"
            });
        }
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.vertical-center{
    display: flex;
    align-items: center;
}
.level-item input{
    color: rgb(46, 142, 252);
}
.label{
    font-size: 13px !important;
    text-transform: uppercase !important;
}
input, select{
    color: rgb(46, 142, 252) !important;
}
.b-checkbox.checkbox input[type=checkbox] + .check {
  -ms-transform: scale(1) !important; /* IE */
  -moz-transform: scale(1) !important; /* FF */
  -webkit-transform: scale(1) !important; /* Safari and Chrome */
  -o-transform: scale(1) !important; /* Opera */
  transform: scale(0.9) !important;
  padding: 10px !important;
}
input[type=checkbox]
{
  /* Double-sized Checkboxes */
  -ms-transform: scale(1.5) !important; /* IE */
  -moz-transform: scale(1.5) !important; /* FF */
  -webkit-transform: scale(1.5) !important; /* Safari and Chrome */
  -o-transform: scale(1.5) !important; /* Opera */
  transform: scale(1.5) !important;
  padding: 10px !important;
}
.vue-swatches__swatch{
    margin-bottom: 10px !important;
}
.radio-label{
    font-size: 12.5px !important;
    color: rgb(46, 142, 252) !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Manage/Behaviors/AddContent.vue